import React from "react";
import { Link } from "react-router-dom";

const CodeLabItem = ({
  preview,
  tutorial,
  fork,
  sandbox,
  title,
  prefix,
  live,
  description,
  assets,
  techList,
  posted,
  updated,
}) => {
  return (
    <li>
      <div className="archive-inner">
        <Link
          to={{
            pathname: `view/${prefix}`,
            state: {
              posted: posted,
              updated: updated,
              title: title,
              description: description,
              assets: assets,
              fork: fork,
              sandbox: sandbox,
              live: live,
              tutorial: tutorial,
              techList: techList,
            },
          }}
        >
          <div
            className="code-image"
            style={{
              backgroundImage: `url(${preview})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "100% auto",
            }}
          ></div>
        </Link>
        <div className="code-description">
          <div className="topWrapper">
            <Link
              to={{
                pathname: `view/${prefix}`,
                state: {
                  posted: posted,
                  updated: updated,
                  title: title,
                  description: description,
                  assets: assets,
                  fork: fork,
                  sandbox: sandbox,
                  live: live,
                  tutorial: tutorial,
                  techList: techList,
                },
              }}
            >
              <h3>{title}</h3>
            </Link>
            {updated ? (
              <span>
                posted: {posted} / updated: {updated}
              </span>
            ) : (
              <span>posted: {posted}</span>
            )}
          </div>
        </div>
      </div>
    </li>
  );
};

export default CodeLabItem;
